import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { TrailerHandlingListState, TrailerHandlingListStateModel } from './trailer-handling-list.state';
import { Store } from '@ngxs/store';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../../../list-search-criteria';
import { TrailerHandlingListInitialState, TrailerHandlingListLoad } from './trailer-handling-list.action';
import { take } from 'rxjs/operators';
import { HubBrief, HubContextFacade } from '../../../../../administration';
import { CouplingPlanSearchCriteria } from '../../../models/allocation-register-uli-details/trailer-handling/register-uli-trailer-handling.model';

@Injectable({ providedIn: 'root' })
export class TrailerHandlingListFacade {
  listDto$: Observable<TrailerHandlingListStateModel> = this.store.select(TrailerHandlingListState.getState);
  loaded$: Observable<boolean> = this.store.select(TrailerHandlingListState.getLoaded);

  constructor(
    private store: Store,
    private hubContextFacade: HubContextFacade,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
  ) {}

  loadAll(): void {
    combineLatest([
      this.hubContextFacade.selectedHub$,
      this.listSearchCriteriaFacade.getSearchCriteriaByListType(ListSearchCriteriaType.CouplingPlan),
    ])
      .pipe(take(1))
      .subscribe(([hub, searchCriteria]: [HubBrief, CouplingPlanSearchCriteria]) => {
        const hubId = hub.id;
        this.store.dispatch(new TrailerHandlingListLoad({ hubId, searchCriteria }));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new TrailerHandlingListInitialState());
  }
}
